export default __webpack_public_path__ + "static/media/ezzam.0d31a150.jpg";